var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"size":"18"},on:{"click":function($event){return _vm.exportCSVFile()}}},[_vm._v("mdi-download")])
}
var staticRenderFns = []

export { render, staticRenderFns }